import React from 'react';
import styled from 'styled-components';
import VideoPlayer from './VideoPlayer';

const PageContainer = styled.div`
  padding: 24px;
  background: #f5f7fa;
  min-height: 100vh;
`;

const PageHeader = styled.header`
  background: white;
  padding: 24px 32px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  margin-bottom: 24px;
  border-left: 4px solid #667eea;
`;

const PageTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 4px;
`;

const PageSubtitle = styled.p`
  color: #718096;
  font-size: 0.875rem;
`;

const VideoSection = styled.section`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
`;

const SectionHeader = styled.div`
  padding: 20px 24px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
  
  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1a202c;
    margin: 0;
  }
  
  i {
    color: #667eea;
    font-size: 1.125rem;
  }
`;

const SectionContent = styled.div`
  padding: 24px;
`;

const LiveStream = () => {
  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Live Stream</PageTitle>
        <PageSubtitle>Broadcast and monitor your live content</PageSubtitle>
      </PageHeader>

      <VideoSection>
        <SectionHeader>
          <i className="fas fa-video"></i>
          <h2>Live Stream Player</h2>
        </SectionHeader>
        <SectionContent>
          <VideoPlayer />
        </SectionContent>
      </VideoSection>
    </PageContainer>
  );
};

export default LiveStream;
